import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { isLoggedIn, isAdminLoggedIn } from '../../utils/auth'

const ProtectedRoute = () => {
    return isLoggedIn() ? <Outlet /> : <Navigate to={'/login'} />;
}

const AdminProtectedRoute = () => {
    return isAdminLoggedIn() ? <Outlet /> : <Navigate to={'/admin/login'} />;
}


export { ProtectedRoute, AdminProtectedRoute };
